import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { INITIAL_DASHBOARD_STATE } from "../constants/dashboard.constants";

export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async (isAgent: boolean) => {
    const url = isAgent ? "api/Dashboard/SugAgent" : "api/Dashboard/Summary";
    const response: any = await axios.get(url);
    return response.data || response?.response?.data;
  }
);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: INITIAL_DASHBOARD_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload?.result ?? {};
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default dashboardSlice.reducer;
